import { render } from "./CapitoleLoader.vue?vue&type=template&id=bd100c64&scoped=true&ts=true"
import script from "./CapitoleLoader.vue?vue&type=script&lang=ts"
export * from "./CapitoleLoader.vue?vue&type=script&lang=ts"

import "./CapitoleLoader.vue?vue&type=style&index=0&id=bd100c64&scoped=true&lang=css"

import exportComponent from "/builds/weleaf/twd-origination-vue/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bd100c64"]])

export default __exports__